import { IDanhSachDangKyNganh2UpdateDuyetRequest } from "../../model/request/quan-ly-nganh-2/IDanhSachDangKyNganh2UpdateDuyetRequest";
import { apiClient } from "../apiClient";

const DANH_SACH_DANG_KY_NGANH_2_ENDPOINT = 'danh-sach-dang-ky-nganh-2';
export const danhSachDangKyNganh2Api = {
    SelectByDotDangKy: (id_dot_dang_ky: number) => apiClient.get(`${DANH_SACH_DANG_KY_NGANH_2_ENDPOINT}/dot-dang-ky/${id_dot_dang_ky}`),
    Duyets: (request: IDanhSachDangKyNganh2UpdateDuyetRequest) => apiClient.patch(`${DANH_SACH_DANG_KY_NGANH_2_ENDPOINT}/duyets`, request)
}